const translations = {
  hero: {
    title: "Itaobuy Spreadsheet: La Guida Italiana Numero 1 nel 2026",
    subtitle: "Trova, confronta e analizza migliaia di prodotti con guide dettagliate, informazioni aggiornate e consigli creati per utenti italiani.",
    ctaPrimary: "Esplora Itaobuy Spreadsheet",
    ctaSecondary: "Vai alla piattaforma principale",
    trustBadge1: "Guide aggiornate 2026",
    trustBadge2: "Analisi prodotti",
    trustBadge3: "Consigli sicurezza",
    trustBadge4: "Risorse gratuite",
  },
  trust: {
    title: "Perché migliaia di utenti cercano Itaobuy Spreadsheet?",
    cards: [
      {
        icon: "ri-search-eye-line",
        title: "Ricerca prodotti intelligente",
        desc: "Trova rapidamente prodotti interessanti organizzati per categoria con filtri avanzati e suggerimenti personalizzati.",
      },
      {
        icon: "ri-file-info-line",
        title: "Informazioni dettagliate",
        desc: "Analizza prezzo, qualità, recensioni e caratteristiche di ogni prodotto prima dell'acquisto.",
      },
      {
        icon: "ri-camera-line",
        title: "QC Photos",
        desc: "Controlla immagini reali e foto di qualità prima di prendere una decisione d'acquisto.",
      },
      {
        icon: "ri-global-line",
        title: "Guida italiana",
        desc: "Tutte le informazioni spiegate in lingua italiana, create per le esigenze degli utenti italiani.",
      },
    ],
  },
  comparison: {
    title: "Itaobuy Spreadsheet vs ricerca tradizionale",
    rows: [
      { feature: "Tempo ricerca", itaobuy: "Molto veloce", manual: "Lento" },
      { feature: "Prodotti organizzati", itaobuy: "✓", manual: "No" },
      { feature: "Filtri categoria", itaobuy: "✓", manual: "Limitati" },
      { feature: "Guide italiane", itaobuy: "✓", manual: "No" },
      { feature: "Aggiornamenti", itaobuy: "Frequenti", manual: "Variabili" },
    ],
  },
  features: {
    title: "Cosa puoi trovare su Itaobuy Spreadsheet?",
    items: [
      { icon: "ri-footprint-line", name: "Scarpe" },
      { icon: "ri-t-shirt-line", name: "Moda" },
      { icon: "ri-user-star-line", name: "Streetwear" },
      { icon: "ri-handbag-line", name: "Accessori" },
      { icon: "ri-fire-line", name: "Prodotti virali" },
      { icon: "ri-bar-chart-line", name: "Nuovi trend" },
    ],
  },
  security: {
    title: "Itaobuy Spreadsheet è sicuro?",
    subtitle: "La sicurezza è una priorità. Prima di utilizzare qualsiasi piattaforma online:",
    tips: [
      "Verifica sempre le informazioni",
      "Utilizza connessioni HTTPS",
      "Proteggi i dati personali",
      "Controlla recensioni e fonti",
    ],
  },
  faq: {
    title: "Domande frequenti su Itaobuy Spreadsheet",
    items: [
      {
        q: "Cos'è Itaobuy Spreadsheet?",
        a: "Itaobuy Spreadsheet è una piattaforma che organizza e cataloga migliaia di prodotti in un formato facile da consultare, permettendo agli utenti di trovare rapidamente ciò che cercano con informazioni dettagliate su prezzi, qualità e recensioni.",
      },
      {
        q: "Itaobuy Spreadsheet è gratuito?",
        a: "Le informazioni e le guide presenti su questa piattaforma sono completamente gratuite. Puoi esplorare tutte le categorie e i prodotti senza alcun costo.",
      },
      {
        q: "Come utilizzare Itaobuy Spreadsheet?",
        a: "Utilizzare Itaobuy Spreadsheet è semplice: basta selezionare una categoria dal menu a discesa, esplorare i prodotti disponibili e cliccare sui link per accedere direttamente ai prodotti che ti interessano.",
      },
      {
        q: "Dove trovare i prodotti migliori?",
        a: "I prodotti migliori sono organizzati per categoria. Puoi navigare tra scarpe, abbigliamento, accessori e molto altro utilizzando il nostro menu di navigazione o i pulsanti categoria nella homepage.",
      },
      {
        q: "Itaobuy Spreadsheet è sicuro?",
        a: "Sì, la piattaforma fornisce informazioni trasparenti e verificate. Consigliamo sempre di utilizzare connessioni sicure, verificare le recensioni e proteggere i propri dati personali durante gli acquisti online.",
      },
    ],
  },
  nav: {
    selectCategory: "Seleziona una categoria",
    home: "Home",
  },
  footer: {
    description: "Il tuo punto di riferimento italiano per Itaobuy Spreadsheet. Guide, recensioni e consigli per trovare i migliori prodotti online.",
    guides: "Guide",
    categories: "Categorie",
    legal: "Legale",
    copyright: "© 2026 Itaobuy Spreadsheet Italia. Tutti i diritti riservati.",
  },
  buttons: {
    itaobuySheet: "itaobuy sheet",
    buyItNow: "buy it now",
  },
  article: {
    title: "Guida Completa Itaobuy Spreadsheet 2026: Come Trovare i Migliori Prodotti",
    backToHome: "← Torna alla homepage",
    intro: "Benvenuti nella guida più completa in italiano su Itaobuy Spreadsheet. In questo articolo esploreremo tutto ciò che devi sapere per utilizzare al meglio questa piattaforma e trovare i prodotti che stai cercando.",
    sections: [
      {
        heading: "Cos'è Itaobuy Spreadsheet e come funziona",
        content: "Itaobuy Spreadsheet rappresenta una soluzione innovativa per chi cerca prodotti online in modo organizzato ed efficiente. Si tratta di un sistema di catalogazione che raccoglie migliaia di prodotti suddivisi per categorie, permettendo agli utenti di navigare facilmente tra diverse opzioni di acquisto. La particolarità di Itaobuy Spreadsheet è la sua struttura intuitiva: ogni prodotto è accompagnato da informazioni dettagliate come prezzo, valutazioni degli utenti, immagini reali (QC photos) e link diretti per l'acquisto. Questo approccio elimina la necessità di cercare manualmente su molteplici piattaforme, centralizzando tutto in un unico punto di accesso. Per gli utenti italiani, rappresenta uno strumento prezioso perché tutte le guide e le spiegazioni sono disponibili in lingua italiana, rendendo l'esperienza di ricerca prodotti molto più accessibile e comprensibile.",
      },
      {
        heading: "Le categorie di prodotti disponibili",
        content: "Una delle caratteristiche più apprezzate di Itaobuy Spreadsheet è la vasta gamma di categorie disponibili. Gli utenti possono esplorare sezioni dedicate a scarpe di ogni tipo, dallo sportivo all'elegante, abbigliamento moda con felpe, t-shirt, giacche e pantaloni, accessori come borse, cinture e profumi, oltre a categorie speciali come jersey sportivi e set completi. Ogni categoria viene costantemente aggiornata con nuovi prodotti, garantendo che gli utenti abbiano sempre accesso alle ultime tendenze e alle migliori offerte disponibili sul mercato. La suddivisione per categorie rende la navigazione estremamente intuitiva: basta selezionare l'area di interesse e sfogliare i prodotti disponibili con tutte le informazioni necessarie per prendere una decisione d'acquisto informata.",
      },
      {
        heading: "Come utilizzare le QC Photos per valutare i prodotti",
        content: "Le QC Photos (Quality Control Photos) sono uno degli strumenti più potenti offerti da Itaobuy Spreadsheet. Si tratta di fotografie reali dei prodotti, scattate prima della spedizione, che permettono agli acquirenti di verificare la qualità effettiva di ciò che stanno per comprare. Per utilizzare al meglio le QC Photos, consigliamo di controllare attentamente i dettagli delle cuciture per l'abbigliamento, la qualità dei materiali per borse e accessori, la precisione dei loghi e delle finiture, e la corrispondenza tra le foto e la descrizione del prodotto. Questo processo di verifica visiva riduce significativamente il rischio di ricevere prodotti diversi da quanto aspettato, aumentando la soddisfazione complessiva dell'esperienza di acquisto.",
      },
      {
        heading: "Consigli per un acquisto sicuro",
        content: "La sicurezza è un aspetto fondamentale quando si effettuano acquisti online. Ecco alcuni consigli essenziali per utilizzare Itaobuy Spreadsheet in modo sicuro: verifica sempre che la connessione sia protetta (HTTPS) prima di inserire qualsiasi dato personale; utilizza metodi di pagamento sicuri e tracciabili; controlla sempre le recensioni e le valutazioni di altri utenti prima di procedere con un acquisto; non condividere mai informazioni sensibili come password o dati bancari su canali non verificati; e conserva sempre una copia della conferma d'ordine e delle comunicazioni con il venditore. Seguendo queste semplici regole, potrai goderti un'esperienza di shopping online sicura e piacevole.",
      },
      {
        heading: "Perché scegliere Itaobuy Spreadsheet nel 2026",
        content: "Nel 2026, Itaobuy Spreadsheet si conferma come uno strumento indispensabile per chi cerca prodotti online in modo efficiente. I punti di forza che lo distinguono sono molteplici: l'organizzazione impeccabile dei prodotti per categoria, gli aggiornamenti frequenti che garantiscono contenuti sempre freschi, la disponibilità di guide complete in lingua italiana, la possibilità di accedere a informazioni dettagliate prima dell'acquisto, e una community di utenti attiva che condivide esperienze e consigli. Rispetto alla ricerca manuale tradizionale, Itaobuy Spreadsheet offre un risparmio di tempo significativo e una qualità di informazioni superiore, rendendolo la scelta ideale per chiunque voglia fare acquisti online in modo consapevole e informato.",
      },
    ],
    conclusion: "Itaobuy Spreadsheet rappresenta una risorsa fondamentale per il panorama dello shopping online italiano nel 2026. Con la sua organizzazione intuitiva, le guide dettagliate in italiano e l'accesso a migliaia di prodotti verificati, offre un'esperienza di ricerca e acquisto senza paragoni. Che tu sia un principiante o un esperto di shopping online, Itaobuy Spreadsheet ha qualcosa da offrirti. Inizia oggi stesso a esplorare le categorie e scopri i migliori prodotti disponibili!",
    relatedLinks: "Link utili",
    homeLink: "Torna alla homepage di Itaobuy Spreadsheet",
    exploreLink: "Esplora tutte le categorie",
    exploreLinkUrl: "/",
  },
};

export default translations;